import React from 'react';
import PropTypes from 'prop-types';

import './collapsible.styl'
class Collapside extends React.Component {
    static currentView;

    static propTypes = {
        text: PropTypes.string,
        key: PropTypes.string,
        open: PropTypes.string,
    }

    static defaultPropTypes = {
        open: false,
        key: new Date()
    }

    state = {
        open: this.props.open
    }

    static close = () => Collapside.currentView && Collapside.currentView.setState({open: false})

    turnOnOff() {
        Collapside.close()
        Collapside.currentView = this
        this.setState({open: !this.state.open})
    }

    render = () => <div className={"collapsible" + (this.state.open ? ' show' : '')} key={this.props.key}>
        <div>{this.props.text}</div>
        <div className='collapsible-sign' onClick={this.turnOnOff.bind(this)}></div>
        <div className='collapsible-text'>{this.props.children}</div>
    </div>
}

export default Collapside
